import PropTypes from "prop-types";
import { ShareAltOutlined } from "@/config/antd";
import WebIcon from "@/components/common/Web_Icons";

const EventInfo = ({ date, time, title, description, participants }) => (
  <div className=" text-left">
    <div className="flex justify-between">
      {/* Date and Time section */}
      <div className="flex flex-col items-start gap-1 mb-4">
        <h3 className="text-primary text-small font-bold tracking-wide">
          {date}
        </h3>
        <p className="text-primary text-small">{time}</p>
      </div>

      {/* Share and Icons section */}
      <div className="bg-grey p-2 flex items-center gap-4">
        <span className="text-lighterGrey font-normal text-small uppercase">
          SHARE
        </span>
        <ShareAltOutlined style={{ fontSize: "15px" }} />
        <WebIcon icon="Message" size="small" />
      </div>
    </div>

    {/* Title and Description */}
    <h1 className="heading-regular whitespace-pre-line mb-4">{title}</h1>

    {/* Avatar Cluster */}
    <div className="flex -space-x-2 mb-6">
      {participants.map((participant, index) => (
        <div key={participant.id} className={`${index > 9 ? "hidden" : ""}`}>
          <img
            src={participant.avatar}
            alt={`Participant ${index + 1}`}
            className="w-10 h-10 rounded-full border-2 border-white"
          />
          {index === 9 &&
            participants.length > 9 &&
            participants.length < 10 && (
              <div className="w-8 h-8 rounded-full bg-primary text-white flex items-center justify-center text-xs border-2 border-white">
                +{participants.length - 9}
              </div>
            )}
        </div>
      ))}
    </div>

    <p className="text-bold font-normal mb-8">{description}</p>
  </div>
);

EventInfo.propTypes = {
  date: PropTypes.string,
  time: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  participants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      avatar: PropTypes.string,
    })
  ),
};

export default EventInfo;
